import React, {useState} from 'react'
import Title from '../title/Title'
import img from '../../assets/png/Group -20.png'
import Check from '../check/Check'
import Agenda from '../agenda/Agenda'
import bar from '../../assets/png/Group -91.png'
import pressedIcon from '../../assets/svg/pressedIcon.svg'
import PageControls from '../PageControls/PageControls'
import space1 from '../../assets/png/space 1.png'
import space2 from '../../assets/png/space 2.png'
import space3 from '../../assets/png/space 3.png'
import space4 from '../../assets/png/space 4.png'
import space5 from '../../assets/png/space 5.png'
import space6 from '../../assets/png/space 6.png'
import space7 from '../../assets/png/space 7.png'
import space8 from '../../assets/png/space 8.png'
import space9 from '../../assets/png/space 9.png'

const images = [
    space1
    ,space2
    ,space3
    ,space4
    ,space5
    ,space6
    ,space7
    ,space8
    ,space9]
export default function MoreDetails({nextPage}) {
    const [pressed, setPressed] = useState([])
    const togglePressed = (i) =>{ 
        if(pressed.indexOf(i) === -1){ 
            setPressed([...pressed, i])
        }else{ 
            let filtered = pressed.filter(d => d !== i)
            setPressed(filtered)
        }
    }
    const isPressed = (i) => pressed.indexOf(i) !== -1 
    return (
        <div className="brainstorming">
                        <PageControls nextPage={nextPage} /> 

            <Title title="Almost there!" subtitle="Review your session’s details"/>   
            <div className="brainstormingActions">
                <div className="section">
                <h4 className="actionTitle">Session Length:</h4>
                <h4 className="actionTitle">3 Hours 00 Minutes</h4>

                <h4 className="actionTitle underlinedTitle">Brainstorming agenda</h4>

                <Agenda />
                </div>
                <div className="section">

                <h4 className="actionTitle">What you need to set the space:</h4>
                <div className="spaces">
                    
                    {images.map((el, i) =>
                    <div onClick={()=>togglePressed(i)} className={"space hoverImage " + (isPressed(i) ? 'pressed':'') }>
                        {isPressed(i)? <img src={pressedIcon} className="pressedIcon" alt=""/> :''}
                        <img src={el} className={ (isPressed(i) ? 'pressed':'')} alt=""/>
                    </div>

                         )}
                </div>
                
                <Check text="Email me the shopping list" />
                <Check text="Send e-invite to the team." />
                <Check text="Send a reminder an hour before the session starts" />
                </div>
                <div className="section"></div>
                <div className="section fixed">
                    <div className="bar">
                        <img src={bar} alt="" />
                    </div>
<div className="buttons end">
            <button className="outline noPadding">Save as draft</button>
            <button className="next" onClick={() => nextPage(1)}>Next</button>
        </div>
</div>
                </div>
        </div>
    )
}
